import { render, staticRenderFns } from "./AddShipRepairPractice.vue?vue&type=template&id=60f3fd3c"
import script from "./AddShipRepairPractice.vue?vue&type=script&lang=ts"
export * from "./AddShipRepairPractice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports